
import { Component, Vue } from 'vue-property-decorator';
import { AmplitudeEvent } from '@/analytics/Analytics';

@Component
export default class TheMainMenuProblemButton extends Vue {
  AmplitudeEvent = AmplitudeEvent;
}
